module.exports = __webpack_public_path__ + "static/img/1.86f478a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/3/eng/1.png
// module id = p64U
// module chunks = 0